import request from '@/util/request'


export const resourcesUpdateList = (data) => request.post('/api/resourcesUpdateList', data);  //获取变更请求列表
export const resourcesUpdateDetail = (data) => request.post('/api/resourcesUpdateDetail', data);  //获取变更请求详情